import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import NotFoundView from '../common/NotFoundView'
import SettingsHome from './SettingsHome'
import CatalogHome from './Catalog'

function Settings () {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <SecureRoute path={`${path}`} exact>
        <SettingsHome />
      </SecureRoute>
      <SecureRoute path={`${path}/catalog`} exact>
        <CatalogHome />
      </SecureRoute>
      <SecureRoute path='*'>
        <NotFoundView />
      </SecureRoute>
    </Switch>
  )
}

export default Settings
